import axios from 'axios';

const apiClient = axios.create({
  //TODO: Use env file
  //baseURL: `https://hrng-backend.herokuapp.com`,
  baseURL: process.env.VUE_APP_REST_HTTP,
  withCredentials: false, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export default {
  fetchData(path) {
    return apiClient.get(path);
  },
};
